module.exports = __webpack_public_path__ + "static/assets/6326e8bcb40eb6313520183faccc06a3.png";